import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getReserves({ status, page, pharmacy, rut }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.RESERVE}/reserve/country/${Enviroment.LANGUAGE}/status/${status}/page/${page}/list`,
			params: { dni: rut, pharmacy },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getReserveByTrxId(trx_id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.RESERVE}/reserve/get-by-operation-id/${trx_id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async postChangeStatus(id, status, body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.RESERVE}/reserve/${id}/status/${status}`,
			body: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
